export const osSeriesNames = {
  r: 'AMD',
  rx: 'AMD',
  nv: 'NVIDIA',
};
